import * as React from 'react';
import { auth } from '../../App';
import MenuContent from './MenuContent';
import { LogoutRounded as LogoutRoundedIcon } from '@mui/icons-material';
import { Avatar, Box, Button, Divider, Drawer, drawerClasses, Stack, Typography, useColorScheme } from '@mui/material';
import { useUserData } from '../Home';

export default function SideMenuMobile({ open, toggleDrawer }) {

    const { mode, setMode } = useColorScheme();

    const { userData } = useUserData();

    return (

        <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}
        sx={{
            [`& .${drawerClasses.paper}`]: {
            backgroundImage: 'none',
            backgroundColor: 'background.paper',
            },
        }}>
            <Stack sx={{ height: '100%', minWidth: 250 }}>
                <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
                    <Stack direction="row" sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}>
                        <Avatar sizes="small" alt={userData?.name} src="" sx={{ width: 24, height: 24 }}/>
                        <Typography component="p" variant="h6">{userData?.name}</Typography>
                        <Box width={6}/>
                    </Stack>
                </Stack>
                <Divider />
                <Stack sx={{ flexGrow: 1 }}>
                    <MenuContent />
                    <Divider />
                </Stack>
                <Stack sx={{ p: 2 }}>
                    <Button 
                    variant="outlined" 
                    fullWidth 
                    onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')} 
                    sx={{ mb: 1 }}>Switch theme</Button>
                    <Button 
                    variant="outlined" 
                    fullWidth 
                    startIcon={<LogoutRoundedIcon/>} 
                    onClick={async() => {
                        await auth.signOut();
                    }}>Logout</Button>
                </Stack>
            </Stack>
        </Drawer>

    );

};